import { useState } from 'react';
import { PartIcon } from '@/icons/parts';
import type { PartPhoto } from '@/types/Part';

interface PhotoGalleryProps {
  photos: PartPhoto[];
  iconFallback: string;
  altBase: string;
}

export default function PhotoGallery({ photos, iconFallback, altBase }: PhotoGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (photos.length === 0) {
    return (
      <div className="photo-gallery-main empty">
        <PartIcon iconId={iconFallback} size={160} />
      </div>
    );
  }

  const sorted = [...photos].sort((a, b) => a.order - b.order);
  const active = sorted[activeIndex] ?? sorted[0];
  if (!active) return null;

  return (
    <div className="photo-gallery">
      <div className="photo-gallery-main">
        <img src={active.url} alt={active.alt || altBase} />
      </div>
      {sorted.length > 1 && (
        <div className="photo-gallery-thumbs">
          {sorted.map((ph, i) => (
            <button
              key={ph.storagePath}
              type="button"
              className={`photo-gallery-thumb${i === activeIndex ? ' active' : ''}`}
              onClick={() => setActiveIndex(i)}
              aria-label={`Photo ${i + 1} of ${sorted.length}`}
            >
              <img src={ph.url} alt={ph.alt || `${altBase} photo ${i + 1}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
